import {Component, computed, input} from '@angular/core';
import {FloatLabel} from 'primeng/floatlabel';
import {InputNumber} from 'primeng/inputnumber';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MessageModule} from 'primeng/message';

@Component({
  selector: 'elcia-numeric-input',
  imports: [
    FloatLabel,
    InputNumber,
    TranslateModule,
    MessageModule,
    ReactiveFormsModule,
  ],
  templateUrl: './numeric-input.html',
  styleUrl: './numeric-input.scss'
})
export class NumericInput {
  label = input.required<string>();
  control = input.required<FormControl<number | null>>();
  min = input<number>();
  max = input<number>();
  minFractionDigits = input<number>();
  maxFractionDigits = input<number>();
  mode = input<'decimal' | 'currency'>('decimal');
  currency = input<string>();
  prefix = input<string>();
  suffix = input<string>();

  isRequired = computed(() => this.control().hasValidator(Validators.required));
}